/**
 * @description 返回一个空函数
 *
 */
const noop = function () { };
export default noop;
